import {z} from '@hono/zod-openapi';

/**
 * The tenant list projection: the 18 keys the legacy list query selects, in its
 * `jsonb_build_object` order (the module's `PRICE_REPORT_LIST_ITEM_KEYS`). Every key is emitted,
 * `null` when the stored payload lacks it, and `sellingPrice` and `purchasePrice` are flattened to
 * plain numbers. Documented only; the values come from the stored legacy JSON and stay open.
 */
export const priceReportListResponseSchema = z
  .array(
    z.object({
      id: z.unknown(),
      /** The request row's id, from the join rather than the payload. */
      idRequest: z.string(),
      created: z.unknown(),
      market: z.unknown(),
      currency: z.unknown(),
      vehicle: z.unknown(),
      additionalSettings: z.unknown(),
      attractiveness: z.unknown(),
      purchasePrice: z.unknown(),
      sellingPrice: z.unknown(),
      accuracy: z.unknown(),
      turnover: z.unknown(),
      featuresLevel: z.unknown(),
      customerId: z.unknown(),
      vehicleId: z.unknown(),
      couponNumber: z.unknown(),
      serviceCode: z.unknown(),
      status: z.unknown(),
    })
  )
  .openapi('PriceReportListResponse');
